// `/app/checkout` (WEB-129, `spec/29` §10.1): produtos e links de pagamento do seller.
//
// Rota-PAI: desenha a tela e, por cima, as gavetas de EDITAR vêm das rotas filhas
// (`links/$id` e `products/$id`), com URL própria. As de CRIAR são estado da tela. Só
// roteador aqui: a tela é `features/checkout/checkout-screen.tsx`.

import { createFileRoute, Outlet } from '@tanstack/react-router';
import { CheckoutScreen } from '../../features/checkout/checkout-screen.tsx';
import { FeatureDisabledProvider } from '../../features/checkout/feature-disabled.tsx';

function Checkout() {
  return (
    <FeatureDisabledProvider>
      <CheckoutScreen />
      <Outlet />
    </FeatureDisabledProvider>
  );
}

export const Route = createFileRoute('/app/checkout')({ component: Checkout });
